import { isRejectedWithValue } from '@reduxjs/toolkit';

const handle401Middleware = ({ dispatch }) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    // Check for 401 status
    // `data` is absent on a network error and is a string on a non-JSON body,
    // so this must be optional all the way down — it now runs for EVERY
    // rejected action (the middleware was previously imported but never
    // registered), and a throw here would break the dispatch chain.
    if (action.payload?.status === 401 && action.payload?.data?.detail === "Logged in on another device. Please log in again.") {
      // Perform the necessary action for 401
      dispatch({ type: 'auth/showModal' });
    }
  }
  return next(action);
};

export default handle401Middleware;
